import type { MouseEvent } from 'react'
import { ESTIMATE_PATH, TRACK_PATH, goToSection, navigate, sectionHref } from '../lib/router'

/**
 * A fejlec menupontjai. EGY helyen allnak, mert az asztali sav es a mobil
 * menu ugyanazt a listat mutatja - ket kulon lista elobb-utobb elcsuszna.
 */
export const HEADER_NAV = [
  { hash: 'folyamat', label: 'Hogyan működik', icon: 'flow' },
  { hash: 'anyagok', label: 'Anyagok', icon: 'material' },
  { hash: 'finomsag', label: 'Felület', icon: 'surface' },
  { hash: 'arak', label: 'Árak', icon: 'price' },
  { hash: 'gyik', label: 'GYIK', icon: 'help' }
] as const

export type RouteNavId = 'estimate' | 'track'

export interface RouteNavItem {
  id: RouteNavId
  path: string
  label: string
  icon: string
}

/**
 * A SAJAT UTVONALAK - KULON LISTA, SZANDEKOSAN.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT NEM KERUL A `HEADER_NAV`-BA
 *
 * A `HEADER_NAV` minden eleme a FOOLDAL EGY HORGONYA: a `sectionHref()`
 * `/#anyagok` alaku cimet gyart belole, a kattintas pedig `goToSection()`,
 * ami odanavigal es gorget.
 *
 * A rendeleskovetes viszont SAJAT OLDAL. Ha beleeroltetnenk a horgony-
 * mintaba, a link `/#rendeleskovetes`-re mutatna, a `goToSection` pedig a
 * fooldalon keresne egy `id="rendeleskovetes"` elemet, amit nem talalna -
 * vagyis a menupont a FOOLDALRA vinne, es ott nem tortenne semmi. Pont az
 * a nemán halott link, amit a `router.ts` `goToSection` kommentje mar
 * egyszer megnevez.
 *
 * Ezert a ket lista kulon all, es minden megjelenito - asztali sav, mobil
 * menu, oldalsav - egymas UTAN rajzolja ki oket.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT A CSS-IKONKESZLET, ES NEM AZ `icons.tsx` SVG-I
 *
 * Ez a jel ot masik ikonnal EGY SORBAN all. Az `icons.tsx` kozos `Icon`
 * vaza 24-es `viewBox`-ban, `strokeWidth={2}`-vel rajzol; a fejlecben az
 * ikon 1.05rem ≈ 17px, tehat a vonal 2 × 17/24 ≈ 1.4px-en jelenne meg -
 * LATHATOAN vekonyabban, mint a szomszedjai kemeny 2px-e. Ezt csak ugy
 * lehetne javitani, ha ennel az egy ikonnal elrontanank a kozos vaz
 * vonalvastagsagat - vagyis epp azt az egyetlen szabalyt, amiert az a
 * fajl letezik.
 *
 * A masodik ok: a fejlecben MINDEN ikon animal ravitelre (`nav-flow`,
 * `nav-material`, ...). Egy statikus SVG lenne az egyetlen halott jel a
 * sorban.
 *
 * Az `icons.tsx` maga mondja ki, hogy a CSS-technika az EGYSZERU jeleket
 * birja. Egy fekvo teglalap harant szalaggal (csomag) ilyen: a `shape` es
 * egy `::before`. Es semmi masra nem hasonlit a keszletben - egyedul ez
 * fekvo, a tobbi allo vagy negyzetes.
 * ────────────────────────────────────────────────────────────────────
 */
export const HEADER_ROUTES: readonly RouteNavItem[] = [
  { id: 'estimate', path: ESTIMATE_PATH, label: 'Árkalkuláció', icon: 'price' },
  { id: 'track', path: TRACK_PATH, label: 'Rendeléskövetés', icon: 'track' }
] as const

export default function HeaderNav(): JSX.Element {
  const openSection = (event: MouseEvent<HTMLAnchorElement>, hash: string): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
    event.preventDefault()
    goToSection(hash)
  }

  const openRoute = (event: MouseEvent<HTMLAnchorElement>, path: string): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
    event.preventDefault()
    navigate(path)
  }

  return (
    <nav className="header__nav" aria-label="Fő navigáció">
      {HEADER_NAV.map((item) => (
        <a
          href={sectionHref(item.hash)}
          key={item.hash}
          onClick={(event) => openSection(event, item.hash)}
        >
          <span className={`header__nav-icon header__nav-icon--${item.icon}`} aria-hidden="true">
            <span className="header__nav-icon-shape" />
          </span>
          <span>{item.label}</span>
        </a>
      ))}

      {/*
        A FOOLDALI SAVBAN CSAK A RENDELESKOVETES all a horgonyok utan.

        Az „Arkalkulacio" ide SZANDEKOSAN nem kerul: a fejlecnek mar van egy
        kiemelt, elsodleges gombja, ami oda visz (`header__cta`), es ket,
        ugyanoda mutato celpont egymas mellett csak elbizonytalanitana. A
        rendeleskovetesre viszont nincs mas belepesi pont.
      */}
      {HEADER_ROUTES.filter((item) => item.id === 'track').map((item) => (
        <a href={item.path} key={item.id} onClick={(event) => openRoute(event, item.path)}>
          <span className={`header__nav-icon header__nav-icon--${item.icon}`} aria-hidden="true">
            <span className="header__nav-icon-shape" />
          </span>
          <span>{item.label}</span>
        </a>
      ))}
    </nav>
  )
}
